import { getSmoothStepPath, Position } from 'reactflow';

import type { Point } from '../components/editors/edge_types/routing';

/** Legacy (routing-disabled) path: loop arc for backward/self-loop edges, smoothstep otherwise. */
export const legacyEdgePath = (sourceX: number, sourceY: number, targetX: number, targetY: number, isSelfLoop: boolean): { path: string; mid: Point } => {
  if (isSelfLoop) {
    const loopX = sourceX + 90;
    const loopY = sourceY - 70;
    const path = `M ${sourceX} ${sourceY} C ${sourceX + 40} ${sourceY}, ${loopX} ${sourceY - 20}, ${loopX} ${loopY} C ${loopX} ${sourceY - 120}, ${targetX - 40} ${targetY - 40}, ${targetX} ${targetY}`;
    return { path, mid: { x: loopX, y: loopY } };
  }
  if (sourceX > targetX) {
    const loopY = Math.min(sourceY, targetY) - 120;
    const path = `M ${sourceX} ${sourceY} C ${sourceX + 60} ${sourceY}, ${sourceX + 60} ${loopY}, ${(sourceX + targetX) / 2} ${loopY} C ${targetX - 60} ${loopY}, ${targetX - 60} ${targetY}, ${targetX} ${targetY}`;
    return { path, mid: { x: (sourceX + targetX) / 2, y: loopY } };
  }
  const [path, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition: Position.Right,
    targetX,
    targetY,
    targetPosition: Position.Left,
    borderRadius: 0,
  });
  return { path, mid: { x: labelX, y: labelY } };
};
